<template>
     <section id="footer">
        <div>
          <span>Stay connected with Nikkia</span>
        </div>
        <ul class="icons">
          <li>
            <a
              href="https://twitter.com/Nikkia4Boston"
              class="icon brands alt fa-twitter"
              target="_blank"
              ><span class="label">Twitter</span></a
            >
          </li>
          <!-- <li>
            <a
              href="https://www.instagram.com/nikkia4boston/"
              class="icon brands alt fa-facebook-f"
              ><span class="label">Facebook</span></a
            >
          </li> -->
          <li>
            <a href="https://www.instagram.com/nikkia4boston/" class="icon brands alt fa-instagram"
            target="_blank"
              ><span class="label">Instagram</span></a
            >
          </li>
          <li>
            <a href="mailto:nikkiajeancharles@gmail.com" class="icon solid alt fa-envelope"
            target="_blank"
              ><span class="label">Email</span></a
            >
          </li>
        </ul>
        <ul class="copyright">
          <li>&copy;Paid for by the Jean-Charles Committee</li>
          <li><a href="https://linktr.ee/kwalters01" target="_blank">Developed by Kaia Walters</a></li>
        </ul>
      </section>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style>
@import "/src/assets/css/main.css";
@import "/src/assets/css/noscript.css";

#footer {
  background-color:#8b0c0e;
}
</style>
